module.exports = "/static/media/logo-phone-by-webcom.64c2d97e.svg";